import { useContext, useState } from "react";
import { BundleTypes, WidgetShowOptions } from "../constants";
import { Button, Checkbox, Collapsible, Divider, FormLayout, Select } from "@shopify/polaris";
import styles from "./Placeholder.module.css";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { PlaceholderContext } from "./Placeholder";
import BundleTypeSettings from "../CommonFields/BundleTypeSettings";
import GeneralSettings from "../CommonFields/GeneralSettings";

const PlaceholderSettingsForm = () => {
    const context = useContext(PlaceholderContext);
    const [expandSettings, setExpandSettings] = useState(true);
    if (!context) return;
    const {
        fields: {
            general_settings: { show_bundle_on_product_page, show_multiple_bundles_on_product_page },
            bundles_settings: {
                enable_stock_control,
                out_of_stock_text,

                work_only_with_widget,
                bundle_position,
            },
            show_bundle_widget,
            free_shipping,
        },
        handleNext,
        dispatchBundleConfig,
        bundleConfig,
        submit,
    } = context;

    return (
        <div className={styles.formWrapper}>
            <div style={{ marginBottom: "4px" }}>
                <Divider borderColor="border" />
            </div>

            <div className={styles.collapsibleFormBox}>
                <GeneralSettings
                    bundleConfig={bundleConfig as any}
                    dispatchBundleConfig={dispatchBundleConfig}
                    show_bundle_on_product_page={show_bundle_on_product_page}
                    show_multiple_bundles_on_product_page={show_multiple_bundles_on_product_page}
                />
                <div className={styles.dividerStyle}>
                    <Divider borderColor="border" />
                </div>
                <BundleTypeSettings
                    bundleName={BundleTypes.BXGY}
                    bundleConfig={bundleConfig as any}
                    dispatchBundleConfig={dispatchBundleConfig}
                    submit={submit}
                    enable_stock_control={enable_stock_control}
                    out_of_stock_text={out_of_stock_text}
                    work_only_with_widget={work_only_with_widget}
                    bundle_position={bundle_position}
                />
                <div className={styles.dividerStyle}>
                    <Divider borderColor="border" />
                </div>
                <div className={styles.sectionTitleWrapper} onClick={() => setExpandSettings((ps) => !ps)}>
                    <div>For this Bundle</div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            transform: expandSettings ? "rotate(90deg)" : "rotate(270deg)",
                        }}
                    >
                        <MdOutlineArrowBackIosNew size={14} />
                    </div>
                </div>
                <Collapsible
                    open={expandSettings}
                    id="basic-collapsible"
                    transition={{
                        duration: "500ms",
                        timingFunction: "ease-in-out",
                    }}
                    expandOnPrint
                >
                    <FormLayout>
                        <div className={`${styles.formRow} ${styles.row1}`}>
                            <Select
                                label={"Show bundle widget for this bundle"}
                                placeholder={"Bundle widget options"}
                                options={WidgetShowOptions}
                                onChange={(val) => {
                                    dispatchBundleConfig({
                                        payload: val,
                                        key: "show_bundle_widget",
                                    });
                                    show_bundle_widget.onChange(val);
                                }}
                                value={show_bundle_widget.value}
                            />
                        </div>
                        <div className={`${styles.formRow} ${styles.row1}`}>
                            <Checkbox
                                label={"Free Shipping"}
                                {...free_shipping}
                                value=""
                                checked={free_shipping.value}
                                onChange={(val) => {
                                    dispatchBundleConfig({
                                        payload: val,
                                        key: "free_shipping",
                                    });
                                    free_shipping.onChange(val);
                                }}
                            />
                        </div>
                    </FormLayout>
                </Collapsible>
            </div>

            <div className={styles.dividerStyle}>
                <Divider borderColor="border" />
            </div>

            <div className={styles.bottomRowCta}>
                <Button onClick={() => handleNext(2, "Target")}>Back</Button>
                <span></span>
            </div>
        </div>
    );
};

export default PlaceholderSettingsForm;
